import api from "./client";
import {
  CreateWeddingPayload,
  DashboardResponse,
  DiscoverFilters,
  TicketTierRow,
  Wedding,
} from "../types";

export const createWedding = (data: CreateWeddingPayload) => {
  return api.post<Wedding>("/weddings", data);
};

export const updateWedding = (id: string, data: Partial<CreateWeddingPayload>) => {
  return api.patch<Wedding>(`/weddings/${id}`, data);
};

export const getWedding = (id: string) => {
  return api.get<Wedding>(`/weddings/${id}`);
};

export const getPublicWeddings = (filters: DiscoverFilters = {}) => {
  const params: Record<string, string> = {};
  if (filters.dress_code) params.dress_code = filters.dress_code;
  if (filters.vibe) params.vibe = filters.vibe;
  if (filters.requires_21_plus) params.requires_21_plus = "true";
  if (filters.price_min != null) params.price_min = String(filters.price_min);
  if (filters.price_max != null) params.price_max = String(filters.price_max);
  if (filters.last_minute) params.last_minute = "true";
  if (filters.city) params.city = filters.city;
  if (filters.state) params.state = filters.state;
  return api.get<Wedding[]>("/weddings/public", { params });
};

export const searchWeddings = (q: string) => {
  return api.get<Wedding[]>("/weddings/search", { params: { q } });
};

export const getMyWeddings = () => {
  return api.get<Wedding[]>("/weddings/mine");
};

export const getDashboard = () => {
  return api.get<DashboardResponse>("/weddings/dashboard");
};

export const listTiers = (weddingId: string) => {
  return api.get<TicketTierRow[]>(`/weddings/${weddingId}/tiers`);
};

export const upsertTier = (
  weddingId: string,
  data: {
    tier_type: string;
    price_cents: number;
    capacity: number;
    close_date?: string;
    is_active?: boolean;
    label?: string;
  }
) => {
  return api.post<TicketTierRow>(`/weddings/${weddingId}/tiers`, data);
};

export const updateTier = (
  weddingId: string,
  tierId: string,
  data: Partial<{
    price_cents: number;
    capacity: number;
    close_date: string | null;
    is_active: boolean;
    label: string;
  }>
) => {
  return api.patch<TicketTierRow>(`/weddings/${weddingId}/tiers/${tierId}`, data);
};

export const deleteTier = (weddingId: string, tierId: string) => {
  return api.delete(`/weddings/${weddingId}/tiers/${tierId}`);
};

export const uploadCouplePhoto = (payload: {
  wedding_id: string;
  filename: string;
  content_type: string;
  base64: string;
}) => {
  return api.post<{ url: string; wedding: Wedding }>("/weddings/upload-photo", payload);
};
